export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10524.9a74226f.jpg";